<template>
  <div class="col-xs-12 top-document" data-toggle="collapse" :data-target="'#collapse-'+ company.authorID"
       aria-expanded="false" :aria-controls="'collapse-'+ company.authorID" :style="cssProps">
    <table class="col-xs-12" style="width: 100%">
      <tr class="expertColor" :class="{selected: company.selected}">
        <td class="col-md-5 col-xs-4 " style="">
          <table class="table" style="width: 100%;">
            <td class="col-xs-4 col-md-4 text-center" style="vertical-align: middle">
              <flag v-if="company.affiliation && company.affiliation.organisationID" :squared="false" :iso="getIso(company.lastName)" style="height: 100%"/>
            </td>
            <td class="col-xs-8 col-md-8" v-if="company.affiliation && company.affiliation.organisationID" style="">{{company.lastName }}</td>
          </table>
        </td>

        <template>
          <td class="col-md-3 col-xs-4 expertColor" style="">Aster Database</td>
        </template>

        <td class="col-md-2 col-xs-2 text-center se" style="vertical-align: center">
          <select :id="'score-'+ company.authorID" >
            <option value="3">3</option>
            <option value="2">2</option>
            <option value="1">1</option>
          </select>
        </td>
        <td class="col-md-2 col-sm-2 text-center" style="vertical-align: center">
          <a class="btn btn btn-xs btn-success" target="_blank"
             :href="'mailto:' + company.email + '?subject=Request for information&body=I have detected this company through the LEA service. Could you please get back to me to discuss ?'" >Contact </a>
        </td>
      </tr>
    </table>

    <div style="bottom: -9px;position: absolute;width: 100%">
      <span style="margin-left: 49%;background-color: white;">
        <button style="border-radius: 50px;font-size: 0.6rem;" class="btn btn-info btn-xs">
        <i class="fa fa-chevron-down"></i>
        </button>
      </span>
    </div>
  </div>
</template>

<style scoped>

  .expertColor {
    color: var(--company-color);
  }

  .dropdown-expert-action .btn-warning {
    color: var(--company-color);
    border-color: var(--company-color);
  }

  .dropdown-expert-action .btn-warning:hover {
    color: white;
    border-color: var(--company-color);
    background-color: var(--company-color);
  }

  .is-table-row {
    display: table;
  }
  .is-table-row [class*="col-"] {
    float: none;
    display: table-cell;
    vertical-align: top;
  }

  .selected {
    border-left: 5px solid #ffb606;
  }

  .dropdown-menu {
    min-width: 50px;
  }
  div > .dropdown > i {
    cursor: pointer;
  }

  .dropdown-expert-action > ul > li i{
    font-weight: bold;
    margin-right: 5px;
  }

  .dropdown-expert-action ul > li a{
    font-size: 12px;
  }

  .dropdown-expert-action ul > li{
    margin-bottom: 5px;
    font-size: 12px;
  }

  .top-document {
    cursor: pointer;
    /*max-height: 80px;*/
    padding: 15px 0;
    border-bottom: 1px solid #eaeaea;
  }
  .top-document:hover {
    background: #f5f5f5;
  }
</style>
<style>
  .se .br-theme-bars-horizontal .br-widget a {
    height: 10px !important;
    background-color: var(--rating-color) !important;

  }

  .se .br-theme-bars-horizontal .br-widget a.br-active, .se .br-theme-bars-horizontal .br-widget a.br-selected {
    background-color: var(--company-color) !important;
  }
</style>
<script>
import 'jquery-bar-rating/dist/jquery.barrating.min'
import IsoCountries from 'i18n-iso-countries'
import EnCountries from '../../iconFlag/en'
import 'jquery-bar-rating/dist/themes/bars-horizontal.css'
import DropdownCompany from './DropdownCompany'
import {convertHex} from '../../assets/scripts/utils'

IsoCountries.registerLocale(EnCountries)

export default {
  components: {DropdownCompany},
  name: 'CompanySETop',
  props: ['value', 'context'],
  data () {
    return {
      topDocument: null,
      company: null,
      companyColor: '#6a6c6f',
      ratingColor: '#007bff'
    }
  },
  computed: {
    cssProps () {
      return {
        '--company-color': '#' + this.companyColor,
        '--rating-color': convertHex('#' + this.ratingColor, 0.3)
      }
    }
  },
  watch: {
    value: function (val) {
      console.log('companyTop update')
      this.company = val
    },
    company: function (val, oldVal) {
      if (oldVal !== null) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    initScore: (author) => {
      let scoreElement = $('#score-' + author.authorID)

      scoreElement.barrating({
        theme: 'bars-horizontal',
        readonly: true,
        showSelectedRating: false,
        hoverState: false,
        reverse: true,
        initialRating: 0.1
      })
    },
    getIso: (affiliation) => {
      if (typeof affiliation !== 'undefined') {
        let iso = IsoCountries.getAlpha2Code(affiliation.country, 'en')
        if (typeof iso === 'undefined') {
          iso = IsoCountries.toAlpha2(affiliation.code)
        }
        return iso
      }
    }
  },
  beforeMount () {
    this.company = this.value
    this.companyColor = this.$auth.user().profile.color_expert
    this.ratingColor = this.companyColor
    this.topDocument = this.company.docs[0]
  },
  updated () {
    this.topDocument = this.company.docs[0]
    this.initScore(this.company)
  },
  mounted () {
    this.initScore(this.company)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/CompanySETop.vue